import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import FormikProvider from '../../shared/forms/formikProvider.component';
import Modal from '../../shared/modals/modal.component';
import Form from '../../shared/forms/form.component';

import schema from './taxAccountingForm.schema';

import { PeriodPropTypes } from '../shared/propTypes';
import { OptionsPropType } from '../../shared/propTypes/common';

import {
  fetchInitialDataForTaxAccountingModal,
} from './store/actions';
import {
  enabledFlagOptionsSelector,
  plAccountOptionsSelector,
  bsAccountOptionsSelector,
  reclassPlAccountOptionsSelector,
  reclassBsAccountOptionsSelector,
  taxDescriptionNamesOptionsSelector,
  isFetchingInitialDataForModalSelector,
  sharedSelectors,
} from './store/selectors';
import { TaxAccountingPropTypes, TaxAccountingsPropTypes } from '../../shared/propTypes/taxAccounting';

const ModalTitles = {
  ADD: 'Add Tax Accounting',
  EDIT: 'Edit Tax Accounting',
};

class AddTaxAccountingModal extends PureComponent {
  static propTypes = {
    taxAccountings: TaxAccountingsPropTypes,
    entityToEdit: TaxAccountingPropTypes,
    fetchInitialDataForTaxAccountingModal: PropTypes.func.isRequired,
    isFetchingInitialDataForModal: PropTypes.bool.isRequired,
    saveEntity: PropTypes.func.isRequired,
    enabledFlagOptions: OptionsPropType,
    plAccountOptions: OptionsPropType,
    bsAccountOptions: OptionsPropType,
    reclassPlAccountOptions: OptionsPropType,
    reclassBsAccountOptions: OptionsPropType,
    taxDescriptionNamesOptions: OptionsPropType,
    period: PeriodPropTypes.isRequired,
    isSavingInProgress: PropTypes.bool.isRequired,
    hideModal: PropTypes.func.isRequired,
    openForEdit: PropTypes.bool,
    isVisible: PropTypes.bool,
  };

  state = {
    addAnother: false,
  };

  componentDidMount() {
    const { fetchInitialDataForTaxAccountingModal } = this.props;

    fetchInitialDataForTaxAccountingModal();
  }

  save = (formData, { setSubmitting, resetForm }) => {
    const { period, saveEntity, openForEdit } = this.props;
    const { addAnother } = this.state;

    this.setState({ addAnother: false }, () => {
      saveEntity({
        ...formData,
        periodName: period.name,
      }, openForEdit, {
        params: {
          periodName: period.name,
          taxDescription: formData.taxDescription,
        },
        callback: resetForm,
        keepOpenAfterSaving: addAnother,
      });
      setSubmitting(false);
    });
  };

  renderModal = ({ formik, schema }) => {
    const {
      openForEdit,
      enabledFlagOptions,
      plAccountOptions,
      bsAccountOptions,
      reclassPlAccountOptions,
      reclassBsAccountOptions,
      taxDescriptionNamesOptions,
      hideModal,
      isVisible,
      isSavingInProgress,
      isFetchingInitialDataForModal,
    } = this.props;

    const submit = () => {
      this.setState({
        addAnother: false,
      }, () => formik.handleSubmit());
    };

    const submitAndAddAnotherAction = () => {
      this.setState({
        addAnother: true,
      }, () => formik.handleSubmit());
    };

    const reset = () => {
      hideModal();
      formik.resetForm();
    };

    return (
      <Modal
        className="add-tax-accounting-modal"
        title={openForEdit ? ModalTitles.EDIT : ModalTitles.ADD}
        closeAction={reset} // eslint-disable-line react/jsx-no-bind
        dismissText="Cancel"
        dismissAction={reset} // eslint-disable-line react/jsx-no-bind
        submitText="Save"
        submitAction={submit} // eslint-disable-line react/jsx-no-bind
        isSubmitting={formik.isSubmitting || isSavingInProgress}
        submitAndAddAnotherAction={!openForEdit ? submitAndAddAnotherAction : null}
        submitAndAddAnotherText="Save and Add Another"
        isLoading={isFetchingInitialDataForModal}
        isVisible={isVisible}
      >
        <Form
          formik={formik}
          schema={schema}
          openForEdit={openForEdit}
          formContext={{
            enabledFlagOptions,
            plAccountOptions,
            bsAccountOptions,
            reclassPlAccountOptions,
            reclassBsAccountOptions,
            taxDescriptionNamesOptions,
          }}
        />
      </Modal>
    );
  };

  render() {
    const { entityToEdit, taxAccountings, openForEdit } = this.props;

    return (
      <FormikProvider
        schema={schema}
        entityToEdit={entityToEdit}
        onSubmit={this.save}
        render={this.renderModal}
        validationContext={{
          entities: taxAccountings,
          openForEdit,
        }}
      />
    );
  }
}

const mapStateToProps = state => ({
  taxAccountings: sharedSelectors.entitiesSelector(state),
  isSavingInProgress: sharedSelectors.savingEntitySelector(state),
  enabledFlagOptions: enabledFlagOptionsSelector(state),
  plAccountOptions: plAccountOptionsSelector(state),
  bsAccountOptions: bsAccountOptionsSelector(state),
  reclassPlAccountOptions: reclassPlAccountOptionsSelector(state),
  reclassBsAccountOptions: reclassBsAccountOptionsSelector(state),
  taxDescriptionNamesOptions: taxDescriptionNamesOptionsSelector(state),
  isFetchingInitialDataForModal: isFetchingInitialDataForModalSelector(state),
});

export default connect(
  mapStateToProps,
  {
    fetchInitialDataForTaxAccountingModal,
  }
)(AddTaxAccountingModal);
